import React from 'react';
import PropTypes from 'prop-types';
import AuthorAvatar from '../AuthorAvatar/AuthorAvatar';

import './Article.scss';

export default class Article extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        author: PropTypes.shape({
            // null if type !== editorial_content
            username: PropTypes.string.isRequired,
            image: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        contentElement: PropTypes.node.isRequired,
    };

    static defaultProps = {};

    render() {
        const { author, contentElement } = this.props;
        const { image, username } = author;
        return (
            <div className="component-Employer-Marketing-Article">
                <AuthorAvatar
                    imageId={image.src}
                    alt={image.alt}
                    displayText={username}
                />
                {contentElement}
            </div>
        );
    }
}
